module.exports = __webpack_public_path__ + "static/l4-card-3-1e9d2463e8fb052e1a8b5bd5eae29919.png";